<template>
  <div class="fixed z-20 inset-0 overflow-y-auto" aria-labelledby="new-course-modal-title" role="dialog" aria-modal="true"
       @keydown.esc="close">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="close"></div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <form class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
            novalidate @submit.prevent="submit">
        <h3 id="new-course-modal-title" class="text-lg leading-6 font-medium text-gray-900">
          {{ $t('projects.new_course_title') }}
        </h3>
        <p class="mt-1 text-sm text-gray-500">{{ $t('projects.new_course_text') }}</p>

        <div class="mt-4">
          <label for="new-course-title" class="block text-sm font-medium text-gray-700">{{ $t('projects.course_title_label') }}</label>
          <input id="new-course-title" ref="title" v-model="title" type="text" maxlength="255"
                 :placeholder="$t('projects.course_title_placeholder')"
                 :aria-invalid="!!error" :aria-describedby="error ? 'new-course-title-error' : null"
                 class="mt-1 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-bpblue focus:border-bpblue sm:text-sm">
          <p v-if="error" id="new-course-title-error" class="mt-2 text-sm text-red-600">{{ error }}</p>
        </div>

        <div class="mt-5 sm:mt-6 sm:flex sm:flex-row-reverse">
          <button type="submit" :disabled="saving"
                  class="w-full inline-flex justify-center items-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-bpblue text-base font-medium text-white hover:bg-blue-500 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue sm:ml-3 sm:w-auto sm:text-sm">
            <font-awesome-icon v-if="saving" class="mr-2 h-4 w-4 animate-spin" icon="spinner"/>
            {{ $t('projects.create_course') }}
          </button>
          <button type="button" :disabled="saving" @click="close"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue sm:mt-0 sm:w-auto sm:text-sm">
            {{ $t('general.cancel') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CourseService from "@/services/project/CourseService";
import NotificationService from "@/services/notification/NotificationService";

export default {
  name: "NewCourseModal",
  props: {
    academyUuid: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'created'],
  data() {
    return {
      title: '',
      error: '',
      saving: false,
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.title?.focus())
  },
  methods: {
    close() {
      if (!this.saving) {
        this.$emit('close')
      }
    },
    submit() {
      const title = this.title.trim()

      if (!title) {
        this.error = this.$t('projects.course_title_required')
        this.$refs.title?.focus()
        return
      }

      this.error = ''
      this.saving = true

      CourseService.store(this.academyUuid, {title})
          .then((response) => {
            NotificationService.showNotification(this.$t('projects.course_created'), 'success')
            this.$emit('created', response.data?.data ?? response.data)
          })
          .catch((error) => {
            NotificationService.showApiError(error, this.$t('projects.unexpected_error'))
          })
          .finally(() => {
            this.saving = false
          })
    }
  }
}
</script>
